// extracted by mini-css-extract-plugin
export default {"spinner":"ZifiAGl6lMlqpTsWbRtV","rotation":"NaYlhk4luuDu_p9DfahE"};